import { c as _c } from "react/compiler-runtime";
import { AnalyticsSkuViewed } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed';
import type { ReactElement } from 'react';
import { useCreditCardCompareColumnContext } from '../../ColumnContext';
import { useCreditCardCompareOfferContext } from '../../OfferContext';
export function StickyHeaderImpressionWrapper(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  const {
    index
  } = useCreditCardCompareColumnContext();
  const {
    offer: t1
  } = useCreditCardCompareOfferContext();
  const {
    id,
    displayName,
    monetizable,
    product: t2,
    institution: t3
  } = t1;
  const {
    id: productId,
    name: productName
  } = t2;
  const {
    id: institutionId,
    name: institutionName
  } = t3;
  let t4;
  if ($[0] !== children || $[1] !== displayName || $[2] !== id || $[3] !== index || $[4] !== institutionId || $[5] !== institutionName || $[6] !== monetizable || $[7] !== productId || $[8] !== productName) {
    t4 = <AnalyticsSkuViewed id={id} impressionSection="cc_shopping_product_card_sticky" impressionPosition={index} institutionId={institutionId} institutionName={institutionName} monetizable={monetizable} name={displayName} offerId={id} offerName={displayName} productId={productId} productName={productName}>{children}</AnalyticsSkuViewed>;
    $[0] = children;
    $[1] = displayName;
    $[2] = id;
    $[3] = index;
    $[4] = institutionId;
    $[5] = institutionName;
    $[6] = monetizable;
    $[7] = productId;
    $[8] = productName;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}